// extracted by mini-css-extract-plugin
export default {"bookingLogo":"Navbar_bookingLogo__ywDE1","language-select":"Navbar_language-select__tEp47"};